import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import styles from './styles.module.scss';
import services from '../../services';
import { getListarResponsavel, getListarResponsavelPesquisar } from '../../services/api-auto';
import ModalLoading from '../../components/ModalLoading';
import Card from './components/Card'

const claimName = "Responsaveis"

const Administradores = props => {

    const history = useHistory();
    const [responsaveis, setResponsaveis] = useState([])
    const [buscar, setBuscar] = useState('')
    const [ativarBuscar, setAtivarBuscar] = useState(false)
    const [pagina, setPagina] = useState(1)
    const [maxPage, setMaxPage] = useState(1)
    const [modalLoading, setModalLoading] = useState(false);
    const [permiteAdicionarResponsavel, setPermiteAdicionarResponsavel] = useState(services.storage.getClaimValues(claimName, "Cadastrar"));
    const [permiteAlterarResponsavel, setPermiteAlterarResponsavel] = useState(services.storage.getClaimValues(claimName, "Alterar"));
    const [permiteVisualizarResponsavel, setPermiteVisualizarResponsavel] = useState(services.storage.getClaimValues(claimName, "Visualizar"));

    const verMais = (maxPage > pagina);

    const getResponsaveis = async (novaPagina = 1) => {
        try {
            setModalLoading(true)
            const data = await getListarResponsavel(novaPagina);
            setModalLoading(false)
            setPagina(novaPagina)
            console.log(data)
            setResponsaveis(data.data.data)
            setMaxPage(data.data.maxPage)
        } catch (e) {
            setModalLoading(false)
        }
    }
    const addPage = async () => {
        setModalLoading(true)
        const data = (!ativarBuscar) ? await getListarResponsavel(pagina + 1) : await getListarResponsavelPesquisar(pagina + 1, buscar)
        setModalLoading(false)
        setPagina(pagina + 1)
        setResponsaveis([...responsaveis, ...data.data.data])
    }

    const findUsuarios = async () => {
        if (buscar !== '') {
            setModalLoading(true)
            const info = await getListarResponsavelPesquisar(1, buscar)
            setPagina(1)
            setModalLoading(false)
            setResponsaveis(info.data.data)
            setMaxPage(info.data.maxPage)
            setAtivarBuscar(true)
        } else {
            setAtivarBuscar(false)
            getResponsaveis();
        }
    }

    useEffect(() => {
        getResponsaveis()
    }, [])

    useEffect(() => {
    }, [responsaveis])

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                Gestão de Participantes
            </div>
            {
                (permiteAdicionarResponsavel) && (
                    <div className={styles.buttonWrapper}>
                        <button
                            className={`btnInvert ${styles.btAdd}`}
                            onClick={() => { history.push('/responsaveis/detalhes?acao=I') }}
                            disabled={!permiteAdicionarResponsavel}
                        >
                            Adicionar Participante
                        </button>
                        <button
                            className={`btnInvert ${styles.btImportarParticipantes}`}
                            onClick={() => { history.push('/responsaveis/importar') }}
                            disabled={!permiteAdicionarResponsavel}
                        >
                            Importar Base de Participante
                        </button>
                    </div>
                )}
            <div className={styles.subTitle}>
                Participantes cadastrados
            </div>
            <div className={styles.buscar}>
                <FormControl>
                    <TextField type="text" size="small"
                        onChange={(e) => { setBuscar(e.target.value) }}
                        label="Faça sua busca"
                        value={buscar}
                        variant="filled"
                        multiline
                        className="customFilledInput"
                        onKeyDown={
                            (e) => {
                                if (e.key === 'Enter') {
                                    findUsuarios();
                                    e.preventDefault();
                                }
                            }
                        }
                        InputProps={{
                            endAdornment: (
                                <button onClick={findUsuarios} className={styles.searcButton}>
                                    <FontAwesomeIcon icon={faSearch} />
                                </button>
                            )
                        }}
                    />
                </FormControl>
            </div>
            <div className={`${styles.acoesWrapper} ${styles.white}`}>
                {
                    Boolean(responsaveis.length) ?
                        responsaveis.map(
                            (usuario) => <Card usuario={usuario}
                                key={usuario.id}
                                permiteAlterar={permiteAlterarResponsavel}
                                permiteVisualizar={permiteVisualizarResponsavel}
                            />
                        )
                        :
                        (
                            !modalLoading &&
                            (
                                <div>
                                    Nenhum registro encontrado
                                </div>
                            )
                        )
                }
            </div>
            {verMais && (
                <div className={styles.verMaisWrapper}>
                    <button className={`customButton ${styles.verMaisButton}`} onClick={addPage} >
                        Ver mais
                    </button>
                </div>
            )}
            <ModalLoading
                open={modalLoading}
                size="lg"
            />
        </div>
    );

}

export default Administradores;